export default "__VITE_ASSET__2Qlz6DQo__"